import React, { useState, useEffect, useCallback } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  alpha,
} from '@mui/material';
import { ErrorOutlineIcon } from '@/components/common/icons';
import { ROUTES } from '@/routes/routes';
import { colors, error as errorShades } from '@/theme/colors';

export const SessionExpiredDialog: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleSessionExpired = useCallback(() => {
    setOpen(true);
  }, []);

  useEffect(() => {
    window.addEventListener('session-expired', handleSessionExpired);
    return () => {
      window.removeEventListener('session-expired', handleSessionExpired);
    };
  }, [handleSessionExpired]);

  const handleLogin = async () => {
    setOpen(false);
    window.location.href = ROUTES.signIn;
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxWidth: 400,
          width: '90%',
          textAlign: 'center',
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            bgcolor: alpha(colors.error.main, 0.1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 32, color: errorShades.shade7 }} />
        </Box>
        <Typography variant="h6" fontWeight={700} color={colors.text.primary}>
          Session Expired
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pb: 2 }}>
        <Typography variant="body2" color={colors.text.secondary}>
          Your session has expired. Please log in again to continue.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, px: 3 }}>
        <Button
          variant="contained"
          fullWidth
          onClick={handleLogin}
          sx={{
            bgcolor: colors.primary.main,
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 1.5,
            py: 1.2,
            '&:hover': { bgcolor: colors.primary.dark },
          }}
        >
          Login Again
        </Button>
      </DialogActions>
    </Dialog>
  );
};
